/* eslint-disable array-callback-return */
import React, { useState } from "react";
import {
  ViedocButtonElement,
  ViedocCheckboxElement,
  ViedocMenuItemElement,
  ViedocRadioElement,
  ViedocSelectElement,
} from "../../../../../secure/elements/ViedocReactElements";
import { useSelector } from "react-redux";
import { t } from "i18next";
import _ from "underscore";
import NewBinderConfirmation from "./NewBinderConfirmation";
import APP_CONST from "../../../../shared/constants";

const SharedUserForm = ({
  setShowSharedForm,
  showNewBinderConfirmation,
  setshowNewBinderConfirmation,
  recipientTypes,
  userType,
  docDetailsList,
}) => {
  const { docShareUsers } = useSelector((state) => state.document);

  const [selectedRecipients, setSelectedRecipients] = useState([]);
  const [confirmSigning, setConfirmSigning] = useState(false);
  const [confirmNotSigning, setConfirmNotSigning] = useState(false);
  const [isSeperateBinder, setIsSeperateBinder] = useState(true);

  const [confirmCoSignatories, setConfirmCoSignatories] = useState(false);
  const [confirmNoCoSignatories, setConfirmNoCoSignatories] = useState(false);
  const [selectedCosignatory, setSelectedCosingnatory] = useState([]);

  const [selectedGuid, setSelectedGuid] = useState([]);
  const [selectedCoSignGuid, setSelectedCoSignGuid] = useState([]);

  const [signatoryReason, setSignatoryReason] = useState("Select reason");
  const [coSignatoryReason, setCoSignatoryReason] = useState("Select reason");

  const [coSignatoryOption, setCoSignatoryOption] = useState([]);

  const [continueDisabled, setContinueDisabled] = useState(true);

  const [formData, setFormData] = useState({});

  let updatedSignatureReasonList = APP_CONST.SIGNATURE_REASON;

  let signatureReasonListValues = [];
  updatedSignatureReasonList.map((user, index) => {
    signatureReasonListValues.push({
      ...user,
      label: t(`TMF.TEXT_DROPDOWNREASON${index + 1}`),
    });
  });
  let subjectSignatureReason = [];
  APP_CONST.SUBJECT_SIGNATURE_REASON.map((user, index) => {
    subjectSignatureReason.push({
      ...user,
      label: t(`TMF.TEXT_DROPDOWNSUBREASON${index + 1}`),
    });
  });
  let coSignatorySignatureReason = [];
  APP_CONST.COSIGNATORY_REASON.map((user, index) => {
    coSignatorySignatureReason.push({
      ...user,
      label: t(`TMF.TEXT_DROPDOWNCOREASON${index + 1}`),
    });
  });

  const getSignatureReasons = (isCosignatory) => {
    if (isCosignatory && userType === "Subjects") {
      return [...coSignatorySignatureReason, ...signatureReasonListValues];
    } else if (!isCosignatory && userType === "Subjects") {
      return [...subjectSignatureReason, ...signatureReasonListValues];
    } else if (isCosignatory && userType !== "Subjects") {
      return [...signatureReasonListValues];
    } else if (!isCosignatory && userType !== "Subjects") {
      return [...signatureReasonListValues];
    }
  };

  const recipientList = [
    {
      id: 1,
      label: t("TMF.TEXT_VIEDOCCLINICALUSERS"),
      name: "recipient",
      checked: recipientTypes.isenabledforclinicalusers,
      disabled: recipientTypes.isenabledforsubjectusers,
    },
    {
      id: 2,
      label: t("TMF.LABEL_VIEDOCMEUSERS"),
      name: "recipient1",
      checked: recipientTypes.isenabledforsubjectusers,
      disabled: recipientTypes.isenabledforclinicalusers,
    },
  ];

  const signingList = [
    {
      id: 1,
      label: t("ADMIN.DELETEDOCUMENT_NO"),
      checked:
        confirmNotSigning ||
        (!_.isEmpty(selectedRecipients) &&
          userType === "Subjects" &&
          !docDetailsList?.documenttmfside?.isinvestigator),
      disabled: _.isEmpty(selectedRecipients),
      location: "No",
    },
    {
      id: 2,
      label: t("TMF.TEXT_YESSIGNATURE"),
      checked: confirmSigning,
      disabled:
        _.isEmpty(selectedRecipients) ||
        (userType === "Subjects" &&
          !docDetailsList?.documenttmfside?.isinvestigator),
      location: "Yes",
    },
  ];

  const cosignatoriesList = [
    {
      id: 1,
      label: t("ADMIN.DELETEDOCUMENT_NO"),
      checked:
        confirmNoCoSignatories ||
        (!_.isEmpty(selectedRecipients) &&
          userType === "Subjects" &&
          !docDetailsList?.documenttmfside?.isinvestigator),
      disabled: signatoryReason === "Select reason" || confirmNotSigning,
      location: "No",
    },
    {
      id: 2,
      label: t("TMF.TEXT_YESCOSIGANTORY"),
      checked: confirmCoSignatories,
      disabled: signatoryReason === "Select reason" || confirmNotSigning,
      location: "Yes",
    },
  ];

  const sharingUserOption = () => {
    docShareUsers?.clinicalUserOption?.map((options) => {
      if (
        selectedGuid?.includes(options.guid) &&
        !selectedRecipients?.includes(options?.displayNamewithrole)
      ) {
        options.optionDisable = true;
        return options;
      } else {
        options.optionDisable = false;
        return options;
      }
    });

    return userType === "Subjects"
      ? docShareUsers?.subjectUserOption
      : docShareUsers?.clinicalUserOption;
  };

  const setContinueDisbleState = (selectedValue) => {
    if (!selectedValue.length) {
      setContinueDisabled(true);
      setConfirmSigning(false);
      setConfirmNotSigning(false);
      setSignatoryReason("Select reason");
      setConfirmCoSignatories(false);
      setConfirmNoCoSignatories(false);
      setSelectedCosingnatory([]);
      setCoSignatoryReason("Select reason");
    } else if (
      userType === "Subjects" &&
      !docDetailsList?.documenttmfside?.isinvestigator
    ) {
      setContinueDisabled(false);
    }
  };

  const recipientSelectHandler = (event) => {
    setSelectedRecipients(event.target.value);
    setContinueDisbleState(event.target.value);
    let selectedOption = [...event.target.value];
    let coSignatoryOptions = [];

    let getGuid = [];
    getGuid = sharingUserOption()?.map((option) => {
      if (selectedOption?.includes(option?.displayNamewithrole)) {
        return option?.guid;
      } else return "guid";
    });
    coSignatoryOptions = sharingUserOption()?.filter((option) => {
      if (
        selectedCosignatory.length &&
        !selectedCosignatory?.includes(option?.displayNamewithrole) &&
        selectedCoSignGuid?.includes(option?.guid)
      ) {
        option.coSignDisable = true;
        return option;
      } else if (!getGuid?.includes(option?.guid)) {
        option.coSignDisable = false;
        return option;
      } else {
        option.coSignDisable = true;
        return option;
      }
    });
    setSelectedGuid(getGuid);
    if (
      userType !== "Subjects" &&
      selectedCosignatory.length &&
      event.target.value.length
    ) {
      let setSelectedCoSign = [];
      let resetSelectedCoSignGuid = [];

      // eslint-disable-next-line array-callback-return
      selectedCoSignGuid?.map((coSignGuid) => {
        if (!getGuid?.includes(coSignGuid)) {
          let updateSeletedCoSign = sharingUserOption()?.find(
            (userList) =>
              userList.guid === coSignGuid &&
              selectedCosignatory?.includes(userList?.displayNamewithrole)
          );
          setSelectedCoSign.push(updateSeletedCoSign.displayNamewithrole);
          resetSelectedCoSignGuid.push(coSignGuid);
        }
      });

      if (setSelectedCoSign?.length) {
        setSelectedCosingnatory(setSelectedCoSign);
        setSelectedCoSignGuid(resetSelectedCoSignGuid);
      } else {
        setSelectedCosingnatory(setSelectedCoSign);
        setSelectedCoSignGuid(resetSelectedCoSignGuid);
        setContinueDisabled(true);
      }
    }
    setCoSignatoryOption(
      userType === "Subjects"
        ? docShareUsers?.clinicalUserOption
        : coSignatoryOptions
    );
  };

  const cosignatorySelectHandler = (event) => {
    setSelectedCosingnatory(event.target.value);
    setContinueDisabled(
      event.target.value.length >= 1 && coSignatoryReason !== "Select reason"
        ? false
        : true
    );
    let selectedOption = [...event.target.value];
    let getGuid = [];
    getGuid = coSignatoryOption?.map((option) => {
      if (selectedOption?.includes(option?.displayNamewithrole)) {
        return option?.guid;
      } else return "guid";
    });
    setSelectedCoSignGuid(getGuid);
    let cloneCoSignatoryOption = [...coSignatoryOption];
    let coSignOption = [];
    coSignOption = cloneCoSignatoryOption?.map((option) => {
      if (userType !== "Subjects" && selectedGuid?.includes(option?.guid)) {
        option.coSignDisable = true;
        return option;
      } else if (
        getGuid?.includes(option?.guid) &&
        !selectedOption?.includes(option?.displayNamewithrole)
      ) {
        option.coSignDisable = true;
        return option;
      } else {
        option.coSignDisable = false;
        return option;
      }
    });
    setCoSignatoryOption(coSignOption);
  };

  function onSubmit() {}

  const separateBinderAction = () => {
    setIsSeperateBinder(!isSeperateBinder);
  };

  const renderRecipientFields = (form) => {
    return (
      <>
        <div className="binder-step d-flex">
          <div className="label">
            <label>{t("TMF.LABEL_RECIPIENTS")}</label>
          </div>
          <div className="step-content">
            <div>
              {recipientList.map((recipient) => (
                <ViedocRadioElement
                  key={recipient.id}
                  name={recipient.name}
                  size="small"
                  checked={recipient.checked}
                  disabled={recipient.disabled}
                  title = {recipient.disabled ? t("TMF.TEXT_NOTALLOWED") : ""}
                >
                  {recipient.label}
                </ViedocRadioElement>
              ))}
            </div>
            <p
              className="f13 sem-pri-color"
              style={{ margin: "20px 0px 0px 0px" }}
            >
              {t("TMF.LABEL_RECIPIENTSIDS")}
            </p>
            <div>
              <ViedocSelectElement
                size="small"
                multiple
                showSearch
                value={selectedRecipients}
                onChange={(e) => recipientSelectHandler(e)}
              >
                {sharingUserOption()?.map((clinicalList, index) => (
                  <ViedocMenuItemElement
                    key={index}
                    size="small"
                    value={clinicalList.displayNamewithrole}
                    disabled={
                      clinicalList?.disable || clinicalList?.optionDisable
                        ? true
                        : false
                    }
                    style={{ padding: !clinicalList.disable ? "0 10px" : "0" }}
                  >
                    {clinicalList.label}
                  </ViedocMenuItemElement>
                ))}
              </ViedocSelectElement>
            </div>
            <div>
              <ViedocCheckboxElement
                checked={isSeperateBinder}
                size="small"
                onChange={() => separateBinderAction()}
                disabled={
                  userType === "Subjects"
                    ? true
                    : !(selectedRecipients.length >= 2)
                }
              >
                {t("TMF.TEXT_CREATEEACHSEPARATEBINDERS")}
              </ViedocCheckboxElement>
            </div>
          </div>
        </div>
      </>
    );
  };

  const signingConfirmationHandler = (from) => {
    if (from === "No") {
      setConfirmNotSigning(true);
      setConfirmNoCoSignatories(true);
      setConfirmCoSignatories(false);
      setConfirmSigning(false);
      setContinueDisabled(false);
      setSignatoryReason("Select reason");
    } else {
      setConfirmSigning(true);
      setConfirmNotSigning(false);
      setConfirmNoCoSignatories(false);
      setContinueDisabled(true);
      setSignatoryReason("Select reason");
    }
  };

  const signatoryReasonHandler = (event) => {
    setSignatoryReason(event.target.value);
  };

  const coSignatoryReasonHandler = (event) => {
    setCoSignatoryReason(event.target.value);
    setContinueDisabled(
      selectedCosignatory.length >= 1 && event.target.value ? false : true
    );
  };

  const renderSigningFields = (form) => {
    return (
      <>
        <div className="binder-step d-flex">
          <div className="label">
            <label>{t("TMF.TEXT_SIGNING")}</label>
          </div>
          <div className="step-content">
            <div className="d-flex">
              {signingList.map((recipient) => (
                <ViedocRadioElement
                  key={recipient.id}
                  name={"signatories"}
                  size="small"
                  checked={recipient.checked}
                  disabled={recipient.disabled}
                  onChange={() =>
                    signingConfirmationHandler(recipient.location)
                  }
                >
                  {recipient.label}
                </ViedocRadioElement>
              ))}
              {!_.isEmpty(selectedRecipients) &&
                userType === "Subjects" &&
                !docDetailsList?.documenttmfside?.isinvestigator && (
                  <viedoc-icon
                    title={t("TMF.TEXT_INVESTIGATORCONTEXT")}
                    name="info"
                  ></viedoc-icon>
                )}
            </div>
            {confirmSigning && (
              <p
                className="f13 sem-pri-color"
                style={{ margin: "20px 0px 0px 0px" }}
              >
                {t("TMF.LABEL_REASONSIGN")}
              </p>
            )}
            <div style={{ display: confirmSigning ? "block" : "none" }}>
              <ViedocSelectElement
                size="small"
                showSearch
                value={signatoryReason}
                onChange={(e) => signatoryReasonHandler(e)}
              >
                {getSignatureReasons().map((reason, index) => (
                  <ViedocMenuItemElement
                    key={index}
                    size="small"
                    value={reason.value}
                    disabled={reason.value === "Select reason"}
                    hidden={reason.value === "Select reason"}
                  >
                    {reason.label}
                  </ViedocMenuItemElement>
                ))}
              </ViedocSelectElement>
            </div>
          </div>
        </div>
      </>
    );
  };

  const coSignatoryConfirmationHandler = (from) => {
    if (from === "No") {
      setConfirmNoCoSignatories(true);
      setConfirmCoSignatories(false);
      setContinueDisabled(false);
      setCoSignatoryReason("Select reason");
      setSelectedCosingnatory([]);
    } else {
      setConfirmCoSignatories(true);
      setConfirmNoCoSignatories(false);
      setContinueDisabled(true);
    }
  };

  const renderCosignatoriesFields = (form) => {
    return (
      <>
        <div className="binder-step d-flex">
          <div className="label">
            <label>{t("TMF.LABEL_COSIGNATORY")}</label>
          </div>
          <div className="step-content">
            <div className="d-flex">
              {cosignatoriesList.map((recipient) => (
                <ViedocRadioElement
                  key={recipient.id}
                  name={"cosignatories"}
                  size="small"
                  checked={recipient.checked}
                  disabled={recipient.disabled}
                  onChange={() =>
                    coSignatoryConfirmationHandler(recipient.location)
                  }
                >
                  {recipient.label}
                </ViedocRadioElement>
              ))}
              <viedoc-icon
                title={t("TMF.TEXT_COSIGNATORYICONTEXT")}
                name="info"
              ></viedoc-icon>
            </div>
            <p
              className="f13 sem-pri-color"
              style={{
                margin: "25px 0px 0px 0px",
                display: confirmCoSignatories ? "block" : "none",
              }}
            >
              {t("TMF.LABEL_COSIGNATORYIDS")}
            </p>
            <div style={{ display: confirmCoSignatories ? "block" : "none" }}>
              <ViedocSelectElement
                size="small"
                multiple
                showSearch
                value={selectedCosignatory}
                onChange={(e) => cosignatorySelectHandler(e)}
              >
                {coSignatoryOption.map((clinicalList, index) => (
                  <ViedocMenuItemElement
                    key={index}
                    size="small"
                    value={clinicalList.displayNamewithrole}
                    disabled={
                      clinicalList?.disable || clinicalList?.coSignDisable
                        ? true
                        : false
                    }
                    style={{
                      padding: !clinicalList.disable ? "0 10px" : "0",
                    }}
                  >
                    {clinicalList.label}
                  </ViedocMenuItemElement>
                ))}
              </ViedocSelectElement>
            </div>
            <p
              className="f13 sem-pri-color"
              style={{
                margin: "20px 0px 0px 0px",
                display: confirmCoSignatories ? "block" : "none",
              }}
            >
              {t("TMF.LABEL_REASONCOSIGN")}
            </p>
            <div style={{ display: confirmCoSignatories ? "block" : "none" }}>
              <ViedocSelectElement
                size="small"
                showSearch
                value={coSignatoryReason}
                onChange={(e) => coSignatoryReasonHandler(e)}
              >
                {getSignatureReasons(true).map((reason, index) => (
                  <ViedocMenuItemElement
                    key={index}
                    size="small"
                    value={reason.value}
                    disabled={reason.value === "Select reason"}
                    hidden={reason.value === "Select reason"}
                  >
                    {reason.label}
                  </ViedocMenuItemElement>
                ))}
              </ViedocSelectElement>
            </div>
          </div>
        </div>
      </>
    );
  };

  const continueAction = () => {
    setshowNewBinderConfirmation(true);

    let selectedRecipientObject = sharingUserOption()?.filter((user) =>
      selectedRecipients?.includes(user.displayNamewithrole)
    );

    let selectedCoSignatoriesObject = docShareUsers?.clinicalUserOption?.filter(
      (user) => selectedCosignatory?.includes(user.displayNamewithrole)
    );

    let signatureReasonData =
      signatoryReason === "Select reason" ? "" : signatoryReason;
    let coSignatoriesReasonData =
      coSignatoryReason === "Select reason" ? "" : coSignatoryReason;

    let binderFormData = {
      userType: userType,
      subjectList: userType === "Subjects" ? selectedRecipientObject : [],
      clinicalUserList:
        userType === "Clinical User" ? selectedRecipientObject : [],
      isCreateBinderSeperate: isSeperateBinder,
      isRequestForSignature: confirmSigning,
      isToAddCoSignatory: confirmCoSignatories,
      signatureReason: {
        label: signatureReasonData,
        value: signatureReasonData,
      },
      coSignatoriesList: selectedCoSignatoriesObject,
      coSignatoriesReason: {
        label: coSignatoriesReasonData,
        value: coSignatoriesReasonData,
      },
    };
    setFormData(binderFormData);
  };

  const renderBinderDocButton = () => {
    return (
      <>
        <div className="binder-doc-btn">
          <div>
            <ViedocButtonElement
              class="cancel-btn"
              variant="neutral"
              size="small"
              onClick={() => setShowSharedForm(false)}
            >
              <viedoc-icon
                name="arrow"
                slot="prefix"
                class="doc-left-arrow"
              ></viedoc-icon>
              {t("TMF.BUTTON_CANCELBTN")}
            </ViedocButtonElement>
          </div>
          <div className="continue-btn">
            <ViedocButtonElement
              variant="success"
              size="small"
              disabled={continueDisabled}
              onClick={() => continueAction()}
            >
              {t("TMF.TEXT_CONTINUE")}
              <viedoc-icon
                name="arrow"
                slot="suffix"
                class="doc-right-arrow"
              ></viedoc-icon>
            </ViedocButtonElement>
          </div>
        </div>
      </>
    );
  };

  return (
    <>
      {showNewBinderConfirmation && (
        <NewBinderConfirmation
          setShowSharedForm={setShowSharedForm}
          setshowNewBinderConfirmation={setshowNewBinderConfirmation}
          formData={formData}
          docDetail={docDetailsList}
        />
      )}
      {
        <form
          onSubmit={onSubmit}
          style={{ display: showNewBinderConfirmation ? "none" : "" }}
          className={"share-form"}
        >
          <div className={"doc-share-form"}>
            {renderRecipientFields()}
            {renderSigningFields()}
            {renderCosignatoriesFields()}
          </div>
          <div>{renderBinderDocButton()}</div>
        </form>
      }
    </>
  );
};

export default SharedUserForm;
